(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["block-custom-coupon-card"] && !Shopify.designMode) return;
  try {
    const couponButtons = document.querySelectorAll('.coupon-btn[data-coupon]');

  couponButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const coupon = button.getAttribute('data-coupon');
      if (!coupon) return;

      navigator.clipboard.writeText(coupon).then(() => {
        const originalText = button.textContent;
        const copiedText = button.getAttribute('data-copied-text') || originalText;
        button.textContent = copiedText;

        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu-panel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    var panels = document.querySelectorAll('.mega-menu-panel');

    panels.forEach(function (panel) {
      var headers = panel.querySelectorAll('[aria-open]');

      headers.forEach(function (header) {
        var content = header.parentElement.querySelector('[aria-content]');
        if (!content) return;

        var isFirstHeader = header === headers[0];

        header.setAttribute('role', 'button');
        header.setAttribute('tabindex', '0');

        // 初始全部设为关闭
        header.setAttribute('aria-expanded', 'false');
        content.dataset.open = 'false';
        content.style.maxHeight = '0px';

        function openContent() {
          header.setAttribute('aria-expanded', 'true');
          content.dataset.open = 'true';

          // 直接用 scrollHeight，若为 0，则用 'none' 确保可见
          var fullHeight = content.scrollHeight;
          if (fullHeight && fullHeight > 0) {
            content.style.maxHeight = fullHeight + 'px';
          } else {
            content.style.maxHeight = 'none';
          }
        }

        function closeContent() {
          header.setAttribute('aria-expanded', 'false');
          content.dataset.open = 'false';
          content.style.maxHeight = '0px';
        }

        function toggle() {
          var isOpen = header.getAttribute('aria-expanded') === 'true';
          if (isOpen) {
            closeContent();
          } else {
            openContent();
          }
        }

        // ★ 默认展开当前 panel 的第一个手风琴
        if (isFirstHeader) {
          openContent();
        }

        header.addEventListener('click', function (event) {
          event.preventDefault();
          toggle();
        });

        header.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            toggle();
          }
        });
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
